import React from 'react';
import { useTutorialContext } from '../context/TutorialContext';
import './AdvancedTutorialPlaceholder.css';

const AdvancedTutorialPlaceholder = () => {
  const { closeAdvancedTutorial, isAdvancedPlaceholderOpen } = useTutorialContext();

  if (!isAdvancedPlaceholderOpen) return null;

  return (
    <div className="advanced-tutorial-backdrop" role="presentation">
      <section className="advanced-tutorial-modal" role="dialog" aria-modal="true" aria-label="Advanced tutorial">
        <div className="advanced-tutorial-header">
          <div>
            <p>Advanced tutorial</p>
            <h2>More features are coming here.</h2>
          </div>
          <button type="button" onClick={closeAdvancedTutorial} aria-label="Close advanced tutorial">
            ×
          </button>
        </div>
        <p>
          This tutorial will cover range events, tags and filtering, image URLs, import/export backups,
          right-click shortcuts, and dense timeline overflow behavior.
        </p>
        <div className="advanced-tutorial-actions">
          <button type="button" onClick={closeAdvancedTutorial}>
            Close
          </button>
        </div>
      </section>
    </div>
  );
};

export default AdvancedTutorialPlaceholder;
